export const CAMPAIGN_STORE = 'mCampaignStore';
